const isDevelop = /develop/.test(process.env.NODE_ENV);

export default isDevelop;
